import { Controller } from "@hotwired/stimulus";

// The payment modal (new and edit). Which rows show follows what is chosen:
//
//   a member chosen    -> the purpose row
//   an event chosen    -> the club and competitor rows
//   neither chosen     -> the member and the event rows to choose from
//
// Both stay when both are chosen. The amount is required; the button that
// sends the form is disabled and the field says so while it is empty (the
// server checks it too). A new payment disables the "Nová platba" button
// for as long as the modal is open.
//
// The pickers are plain <select>s (tom_select_controller.js), so everything
// is read from them and from the amount input.
export default class extends Controller {
  static targets = ["person", "event", "amount", "amountHint", "submit", "personRow", "targetRow", "eventRow", "eventDetailRow"];
  static values = {newPayment: Boolean, missingText: String};

  connect() {
    this.sync();
    if (!this.newPaymentValue) return;
    const button = document.querySelector("#new_payment_button button");
    if (button && !button.disabled) {
      button.disabled = true;
      this.disabledButton = button;
    }
  }

  disconnect() {
    if (this.disabledButton) this.disabledButton.disabled = false;
    this.disabledButton = null;
  }

  sync() {
    const person = this.hasPersonTarget && this.filled(this.personTarget);
    const event = this.hasEventTarget && this.filled(this.eventTarget);
    this.show(this.personRowTargets, person || !event);
    this.show(this.targetRowTargets, person);
    this.show(this.eventRowTargets, event || !person);
    this.show(this.eventDetailRowTargets, event);
    this.checkAmount();
  }

  filled(select) {
    return Array.from(select.selectedOptions).some((option) => option.value !== "");
  }

  show(rows, visible) {
    rows.forEach((row) => (row.hidden = !visible));
  }

  checkAmount() {
    if (!this.hasAmountTarget) return;
    const missing = this.amountTarget.value.trim() === "";
    this.amountHintTarget.textContent = missing ? this.missingTextValue : "";
    this.amountTarget.closest(".form-group").classList.toggle("has-error", missing);
    if (this.hasSubmitTarget) this.submitTarget.disabled = missing;
  }
}
